import isServer from '../isServer';

const isIpadPro = () => /MacIntel/.test(navigator.platform) && 'ontouchend' in document;
const isIpadGeneral = () => /iPad|iPod/.test(navigator.userAgent);

const isIpad = () => !isServer() && (isIpadPro() || isIpadGeneral());

export default isIpad;
